<template>
  <div class="bitcoin-autocomplete">
  	<b-container class="bitcoin-autocomplete-header">
		<b-row v-if="itemList.length && !subitemList.length" class="bitcoin-autocomplete-header bg-info text-white">
			<b-col>COINS</b-col>
		</b-row>
		<b-row v-if="subitemList.length" class="bitcoin-autocomplete-header bg-info text-white">
		<b-col>EXCHANGE PRICES</b-col>
	</b-row>
	</b-container>
  	<b-container class="bitcoin-autocomplete-pricedate" v-if="subitemList.length">
  		<b-row>
  		<b-col>
  		 <b-button-group>
  		 	<b-button size="sm" :variant="getPriceModeClass('current')" @click="setPriceMode('current')">Current</b-button>
  		 	<b-button size="sm" :variant="getPriceModeClass('historical')" @click="setPriceMode('historical')">Historical</b-button>
  		 </b-button-group>
  		 </b-col>
  		</b-row>
  		<b-row v-if="priceMode=='historical'">
  			<b-col>
  				<b-input-group>
		  			<b-input-group-addon>
				     <i class="fa fa-calendar" aria-hidden="true"></i>
				    </b-input-group-addon>
  					<b-form-input size="sm" type="date" v-model="historicalPriceDate" ref="historical-price-date" />
  				</b-input-group>
  			</b-col>
  		</b-row>
  	</b-container>
    <b-container v-if="itemList.length && !subitemList.length" class="bitcoin-autocomplete-items">
    	<b-row  v-for="item in itemList" class="bitcoin-autocomplete-item">
    		<b-col @click="selectItem(item)">{{ item.FullName }} </b-col>
    	</b-row>
    </b-container>
    <b-container v-if="subitemList.length" class="bitcoin-autocomplete-items">
		<b-row v-for="subitem in subitemList" class="bitcoin-autocomplete-item">
			<b-col @click="selectSubitem(subitem)"><span v-if="isUserExchange(subitem)"><i class="fa fa-star favorite" /></span>{{ displayExchangeItem(subitem) }} <span v-if="priceMode=='current'" v-html="formatCurrentPrice(subitem)"></span></b-col>
		</b-row>
	</b-container>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bitcoin-autocomplete { max-height:200px;  overflow-y: scroll; overflow-x: hidden; border-right: 1px dashed #ced4da}
.bitcoin-autocomplete-items { overflow-y: scroll; overflow-x: hidden; }
.bitcoin-autocomplete-item { border-bottom: 1px solid #ced4da; padding-top: 3px; padding-bottom: 3px}
.favorite { color: gold }
.bitcoin-autocomplete-header {font-size:1em}

</style>


<script>
// import lodash
var _ = require('lodash');

export default {
//  name: '',
  props:{
	  'coins': {type: Object, default: function() { return {} }},
	  'exchanges': {type: Object, default: function() { return {} }},
	  'target': {type: String},
//	  'itemFactory': {type: Function},
	  'coinSelected': {type: Function},
	  'priceSelected': {type: Function},
//	  'subitemFactory': {type: Function},
	  'exchangeSelected': {type: Function},
	  'currency': {type: String},
	  'currencyFactory': {type: Function},
	  'pricePrecision': {type: String, default: function() { return "2" }}, // default to 2 decimal precision

  },
  data () {
    return {
    	'itemList':[],
    	'subitemList': [],
    	'targetRef': null, // holds reference to target field
    	'selectedItem': null,
    	'selectedCoin': null,
  	    'selectedSubitem': null,
  	    'selectedExchange': null,
  	    'subsList': {}, // available price subscription list by coin
  	    'activeSubscriptions': [], // active subscriptions
  	    'lastMatch': null,
  	    'priceMode': "current", // current | historical
  	    'historicalPriceDate': null,

    }
  },
  computed: {
	  	coinList: function() {
			// load cryptocompare coinlist
			//return require('@/assets/data/coinlist.json');
			return this.$root.$store.getters['CCStore/coinList'];
		},
		exchangesByCoin: function() {
			return this.$root.$store.getters['CCStore/exchangesByCoin'];
			// list is fetched by dispatched call in mounted section below

		},
		coinStream: function() {
			// current price stream
			return this.$root.$store.getters['CCStore/coinStream'];
		},
		// user preference fiat currency - default USD
		userCurrency: function() {
			return this.$root.$store.getters['CCStore/myCurrency'];
		},
		myExchanges: function() {
			// load selected exchange list
			return this.$root.$store.getters['CCStore/myExchanges'];
		}
  },
  mounted: function(){
	  // load exchanges
	  this.$root.$store.dispatch('CCStore/getExchangesByCoin');

//	  // Use CryptoCompare coin list if custom list not supplied.
//	  if ((!this.coins) || (Object.keys(this.coins).length == 0)) {
//		  this.coins = this.coinList;
//	  }
//
//	  // Use CryptoCompare exchange list if custom list not supplied.
//	  if ((!this.exchanges) || (Object.keys(this.exchanges).length == 0)) {
//		  this.exchanges = this.exchangesByCoin;
//	  }

	  // set target reference
	  /** @todo There has to be a better way to discover the target in the parent tree */
	  this.targetRef = this.$parent.$refs[this.target] || this.$parent.$parent.$refs[this.target] || this.$parent.$parent.$parent.$refs[this.target];

	  // attach event listener to fire when target field is updated
	  if (this.targetRef) {
		  this.targetRef.$on('input', this.matchCoins);
	  }
  },
  beforeDestroy: function() {
	  // detach event listener from target field
	  if (this.targetRef) {
		  this.targetRef.$off('input', this.matchCoins);
	  }

	  // unsubscribe from live pricing
	  this.unsubscribePricing();
  },
  methods: {

	  // Get coin list, allow overriding using coins attribute
	  getCoinList() {
		  if ((this.coins) && (Object.keys(this.coins).length)) {
			  return this.coins;
		  }
		  if ((this.coinList) && (Object.keys(this.coinList).length)){
			  return this.coinList;
		  }
		  return null;
	  },

	  // Get exchange list, allow overriding using exhanges attribute
	  getExchangeList() {
		  // use custom exchanges provided by tag property
		  if ((this.exchanges) && (Object.keys(this.exchanges).length)) {
			  return this.exchanges;
		  }
		  // user CryptoCompare exchange list
		  if ((this.exchangesByCoin) && (Object.keys(this.exchangesByCoin).length)) {
			  return this.exchangesByCoin;
		  }
		  return null;
	  },

	  setPriceMode(mode) {
		 this.priceMode = mode;
	  },

	  getPriceModeClass(mode) {
		  if (this.priceMode === mode){
			  // bootstrap green background
			  return "success";
		  } else {
			  // bootstrap gray background
			  return "secondary";
		  }
	  },

	  // Coin selected function
	  selectItem(item) {

		  this.selectedItem = item;
		  this.selectedCoin = item.Symbol;


		  // fire custom action defined in tag property
		  if (typeof this.coinSelected === 'function') {
			  this.coinSelected(item);
		  }

		  // Set the last text match to prevent showing more matches instead of exchanges.
		  this.lastMatch = item.Symbol;

		  // set target field equal to selected value
		  if (this.targetRef) {
			  this.targetRef.$el.value = item.Symbol;
			  this.targetRef.$vnode.context[this.targetRef.$vnode.data.model.expression] = item.Symbol;
		  }

		  // subscribe to pricing info for coin
		  if (this.subsList[this.selectedCoin]) {
			  // subscription list already retreived, just subscribe
			  this.subscribePricing(this.selectedCoin);
		  } else {
			  // get subscription list for coin, then subscribe
			  this.$root.$store.dispatch('CCStore/getCoinSubs', this.selectedCoin).then((results) => this.addSubs(results) ).catch(error => {
				  this.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':error});
				  console.log("Caught Promise Error", error) } );

		  }

		  // display list of exchanges for the selected coin
		  this.showExchanges(this.selectedCoin);

	  },

	  // Exchange selected function
	  selectSubitem(item) {

		  this.selectedSubitem = item;
		  this.selectedExchange = item;

		  var currentPrice;
		  var historicalDateObj;
		  var historicalDateEpoch;
		  var historicalDateInput;
//		  var selectedCurrency = this.getSelectedCurrency();

		  var context = this; // store reference to 'this' object for access inside of async calls below

		  // set target field to current price for coin pair on this exchange
		  if (this.priceMode === 'current') {

			  // Get current price from stream
			  currentPrice = this.getCurrentPrice(this.selectedExchange);

			  // if no recent price for this exchange, use aggregate price
			  if (currentPrice == null) {
				  currentPrice = this.getCurrentPrice("CCCAGG");
			  }

			  if (currentPrice != null) {

				  // set target field equal to selected value
				  if (typeof this.subitemSelected === 'function') {
					  this.subitemSelected(item);
				  }

				  if (typeof this.priceSelected === 'function') {
					  this.priceSelected(currentPrice);
				  }

			  } else {
				  // If still no price, then there is no direct trading of this coin pair.
				  // In that case, we will let the CryptoCompare api estimate via conversion from BTC price.

				  this.$root.$store.dispatch('CCStore/getCoinPrice', {"coin": this.selectedCoin, "quoteCoin": this.getSelectedCurrency()}).then((results) => {

					  // set target field equal to selected value
					  if (typeof context.subitemSelected === 'function') {
						  context.subitemSelected(item);
					  }

					  // Check for entry in result hash for selected currency
					  // Example: results['USD']
					  if (results.data[context.getSelectedCurrency()]) {

						  if (typeof context.priceSelected === 'function') {
							  context.priceSelected({'PRICE':results.data[context.getSelectedCurrency()]}); // mimic CCC price object format
						  }

					  } else {
						  context.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':"No price for " + context.selectedCoin + "-" + context.getSelectedCurrency() +" found."});
						  console.log("Error: No price for "+ context.selectedCoin + "-" + context.getSelectedCurrency() + " found.", results);
					  }



				  } ).catch(error => {
					  this.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':error});
					  console.log("Caught Promise Error", error)
					});
			  }

		  } else if (this.priceMode === 'historical') {

			  // require date value
			  if (!this.historicalPriceDate) {
				  this.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':"Please select a historical price date."});
				  this.$refs['historical-price-date'].focus();
				  return null;
			  }

			  historicalDateEpoch = Date.parse(this.historicalPriceDate);
			  if (typeof historicalDateEpoch !== 'number') {
				  // alert invalid date
				  this.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':"Please select a valid historical price date."});
				  this.$refs['historical-price-date'].focus();
				  return null;
			  }

			  historicalDateInput = {
					  'coin': this.selectedCoin,
					  'date': historicalDateEpoch/1000,
					  'exchange': this.selectedExchange,
					  'currency': this.getSelectedCurrency()
			  }

			  // get the price

			  this.$root.$store.dispatch('CCStore/getCoinHistoricalPrice', historicalDateInput).then((results) => {

				  // set target field equal to selected value
				  if (typeof context.subitemSelected === 'function') {
					  context.subitemSelected(item);
				  }

				  if (typeof context.priceSelected === 'function') {
					  context.priceSelected({'PRICE':results}); // mimic CCC price object format
				  }

			  }).catch(error => {
				  this.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':error});
				  console.log("Caught Promise Error", error);
			  });


		  }


	  },

//	  selectPrice(currentPrice) {
//
//		  // default to aggregate price
//		  if (!currentPrice) {
//			  currentPrice = this.getCurrentPrice("CCCAGG");
//		  }
//
//		  if (typeof this.priceSelected === 'function') {
//			  this.priceSelected(currentPrice);
//		  }
//	  },

	  addSubs(results) {

    	  if (results.coin) {
    		  if (!this.subsList[results.coin]) {
    			  this.subsList[results.coin] = results;
    		  }

    		  this.subscribePricing(results.coin);

    	  }

      },

      /*
       * Subscribe to pricing for current coin pair
       */
	  subscribePricing(coin) {

    	  var sourceCoin = this.getSelectedCurrency();
    	  var subCounter = 0;
    	  if ((this.subsList[coin]["data"]) && (this.subsList[coin]["data"][sourceCoin]) && (this.subsList[coin]["data"][sourceCoin]["CURRENT"])) {

    		  for (subCounter = 0; subCounter < this.subsList[coin]["data"][sourceCoin]["CURRENT"].length; subCounter++) {
    			  this.activeSubscriptions.push(this.subsList[coin]["data"][sourceCoin]["CURRENT"][subCounter]);
    		  }
    		  // Add aggregate price
    		  if (this.subsList[coin]["data"][sourceCoin]["CURRENTAGG"]) {
    			  this.activeSubscriptions.push(this.subsList[coin]["data"][sourceCoin]["CURRENTAGG"]);
    		  }

    		  if (this.activeSubscriptions.length > 0) {
    			  this.$root.$store.dispatch('CCStore/subscribe', this.activeSubscriptions);
    		  }
    	  } else {
    		  console.log("No price stream found for pair: "+ coin + "-" + sourceCoin);
    	  }
	  },

	  /*
	   * Removes all subscriptions
	   */
	  unsubscribePricing() {

		  if (this.activeSubscriptions.length > 0) {
			  this.$root.$store.dispatch('CCStore/unsubscribe', this.activeSubscriptions);
		  }
	  },

	  matchCoins() {

//		  var matchCoins = null; // clear previous matches

//		  console.log("Target:" + this.target);
//		  console.log("MatchTarget: ", this.$parent.$parent.$refs[this.target]);

		  var targetRef = this.targetRef;
		  var coinInfo;
		  var sortedCoins;

		  // if target reference exists
		  if (targetRef) {

			  var matchTerm = targetRef.$el.value;

			  /* Show Items
			   * matchItems runs again after item is selected.
			   * do not continue unless matchTerm has changed.
			   */

			  if ((matchTerm) && (matchTerm.toUpperCase() != this.lastMatch)) {

				  this.lastMatch = matchTerm.toUpperCase(); // update lastMatch, toUpperCase so case insensitive

				  // clear previous matches
				  this.itemList.splice(0);
				  this.subitemList.splice(0);

				  sortedCoins = this.filterCoinsByMatch(matchTerm);

				  var context = this; // save reference for use inside iterator
				  _.forEach(sortedCoins, function(record){
					  // add new value to end of array
					  context.$set(context.itemList, context.itemList.length, record);
				  });

//				  var matchRe = new RegExp(matchTerm, 'i');
//
////				  for (var itemCount = 0; itemCount < this.coins.Data.length; itemCount++) {
//				  var coinKeys = Object.keys(this.coins.Data).sort();
//				  for (var itemCount = 0; itemCount < coinKeys.length; itemCount++) {
//					  coinInfo = this.coins.Data[coinKeys[itemCount]]['FullName'];
//					  if (coinInfo.match(matchRe)) {
////						  console.log("Match: ", this.coins[itemCount].toString())
//						  // add new value to end of array
//						  this.$set(this.itemList, this.itemList.length, this.coins.Data[coinKeys[itemCount]]);
//
//					  } else {
////						  console.log("No Match: ", this.coins[itemCount].toString());
//
//					  }
//				  }
			  }
		  }


		  return this.itemList;

	  },

	  filterCoinsByMatch(matchTerm) {

		  var results = [];

		  matchTerm = matchTerm.toLowerCase();

		  function coinSorter(a, b) {

			  var aIndex, bIndex, score;

			  // exact match on coin symbol, so it comes lower in order
			  if (a.Symbol.toLowerCase() === matchTerm) {
				  return -1;
			  }
			  else if (b.Symbol.toLowerCase() === matchTerm) {
				  return 1;
			  }

			  // exact match on coin name, so it comes lower in order
			  if (a.CoinName.toLowerCase() === matchTerm) {
				  return -1;
			  }
			  else if (b.CoinName.toLowerCase() === matchTerm) {
				  return 1;
			  }

			  // Score by symbol first
			  aIndex = a.Symbol.toLowerCase().indexOf(matchTerm);
			  bIndex = b.Symbol.toLowerCase().indexOf(matchTerm);
			  score = aIndex - bIndex;

			  if ((aIndex >= 0) && (bIndex == -1)) {
				  // found in a.Symbol but not b.Symbol
				  return -1;
			  } else if ((bIndex >= 0) && (aIndex == -1)) {
				  // found in b.Symbol but not a.Symbol
				  return 1;

			  } else if ((aIndex >= 0) && (bIndex >= 0)) {
				  // Found in both so sort aplhabetically by symbol

				  // if same postion, sort alphabetically
				  if (score === 0) {
					  // case insensitive compare first
					  score = a.Symbol.localeCompare(b.Symbol);
				  }

				  if (score !== 0) {
					  return score;
				  }
				  // else continue inspecting coin name
			  }


			  // then Score by coin name
			  if (score === 0) {
				  aIndex = a.CoinName.toLowerCase().indexOf(matchTerm);
				  bIndex = b.CoinName.toLowerCase().indexOf(matchTerm);
				  score = aIndex - bIndex;
			  }

			  // then Score alphabetically by name
			  if (score === 0) {
				  // case insensitive compare first
				  score = a.CoinName.toLowerCase().localeCompare(b.CoinName.toLowerCase());

				  // if still equal, do case senstive compare
				  if (score === 0) {
					  score = a.CoinName.localeCompare(b.CoinName);
				  }

			  }

			  return score;

		  }

		  var coinList = this.getCoinList();
		  if ((coinList) && (coinList.Data)) {
			  var matchRe = new RegExp(matchTerm, 'i');
			  _.forEach(coinList.Data, function(record){
				  // Add coins that match term
				  if ((record.FullName) && (record.FullName.match(matchRe))) {
					  results.push(record);
				  }
			  });

			  // sort coins by how well they match
			  return results.sort(coinSorter);
		  }

		  return results; // return empty array


	  },


	  getExchanges(coin) {
		  var exchanges = [];

		  var userExchanges = this.myExchanges;

		  function sorter(a, b) {

			  // Is this the Average Price exchange CCCAGG?
			  if (a === "CCCAGG") {
				  return -1;
			  } else if (b === "CCCAGG") {
				  return 1;
			  }

			  // is either one of the user selected exchanges?
			  else if ((userExchanges[a]) || (userExchanges[b])) {

				  if ((userExchanges[a]) && (!userExchanges[b])) {
					  // a is a user exchange so sort it lower
					  return -1;
				  } else if ((!userExchanges[a]) && (userExchanges[b])) {
					  // a is not a user exchange so sort it higher
					  return 1;
				  } else if ((userExchanges[a]) && (userExchanges[b])) {
					  // if both are user exchanges, sort alphabetically
					  return a.localeCompare(b);
				  }

			  }
			  // Everything else sort alphabetically
			  else {
				  return a.localeCompare(b);
			  }
		  }

		  var exchangeList = this.getExchangeList();

		  if ((exchangeList) && (exchangeList[coin])) {
			  // Add aggregate/avg price
			  exchanges.push("CCCAGG");
			  // Add exchange names
			  exchanges = exchanges.concat(Object.keys(exchangeList[coin]).sort(sorter));
		  }

		  return exchanges;
	  },

	  showExchanges(item) {

		  var exchangeList = this.getExchangeList();
		  if (Object.keys(exchangeList)) {

			  // Clean previous list
			  this.subitemList.splice(0);

			  // Add exchanges to subitem object
			  var newSubitems = this.getExchanges(item);
			  for (var subitemCount = 0; subitemCount < newSubitems.length; subitemCount++) {
				  this.$set(this.subitemList, this.subitemList.length, newSubitems[subitemCount]);
			  }
		  }

	  },

	  displayExchangeItem(exchange) {
		  // Change label for the aggregate price exchange entry
		  if (exchange === "CCCAGG") {
			  return "Average Price ";
		  }
		  return exchange;
	  },

//	  displayExchangePrice(exchange) {
//		  if (exchange === "CCCAGG") {
//			  return "Average Price " + this.getCurrentPrice(exchange);
//		  }
//		  return exchange + " " + this.getCurrentPrice(exchange);
//	  },

	  /**
	   * Returns true if this is a user favorite exchange.
	   */
	  isUserExchange(exchange) {
		  if (this.myExchanges[exchange]) {
			  return true;
		  }
		  return false;
	  },

	  getSelectedCurrency() {

		  var returnVal;

		  // use currency factory function in property
		  if (typeof this.currencyFactory === 'function') {
			  returnVal = this.currencyFactory();
		  }

		  // use currency defined in property
		  else if (this.currency) {
			  returnVal = this.currency;
		  }

		  // use default currency from user profile
		  else if (this.userCurrency) {
			  returnVal = this.userCurrency;
		  }

		  // default to USD
		  if (!returnVal) {
			  returnVal = "USD";
		  }

		  return returnVal.toUpperCase();
	  },

	  // get current coin pair
	  getCoinPair() {

		  var currency = this.getSelectedCurrency();

		  if ((this.selectedCoin) && (currency)) {
			  return this.selectedCoin + "-" + currency;
		  }

		  return null;

	  },

	  // return string with current price from price stream
	  getCurrentPrice(exchange) {
		  var coinPair = this.getCoinPair();
		  if ((this.coinStream[coinPair]) && (this.coinStream[coinPair][exchange])) {
			  return this.coinStream[coinPair][exchange];
		  }

		  /**
		   * @todo need to add direct price lookup to ccc here as a fall-back, not just price stream.
		   */
		  return null;
	  },

	  formatCurrentPrice(exchange) {
		  var currentPrice = this.getCurrentPrice(exchange);
		  var badgeClass = "badge-secondary"
		  var precision = Number(this.pricePrecision);

		  if ((currentPrice) && (currentPrice["PRICE"])) {
			  if (currentPrice["VOLUME24HOUR"]) {
				  badgeClass = "badge-success"
			  }

			  return '<span class="badge ' + badgeClass + '">' + currentPrice["PRICE"].toFixed(precision) + '</span>';
		  }
		  return "";

	  },

	  // return string with current aggregate price for all exchanges
	  getCurrentAggPrice() {
		  var coinPair = this.getCoinPair();
		  if ((this.coinStream[coinPair]) && (this.coinStream[coinPair]["CCCAGG"])) {
			  return this.coinStream[coinPair]["CCCAGG"]["PRICE"];
		  }
		  return "";
	  },




  }
}
</script>




// WEBPACK FOOTER //
// src/components/BitcoinAutocomplete.vue